import axios from "axios";
import { API } from "./api";

const KEY = "lg_admin_session";
export const getAdminSession = () => sessionStorage.getItem(KEY);
export const setAdminSession = (t) => (t ? sessionStorage.setItem(KEY, t) : sessionStorage.removeItem(KEY));
export const adminAuth = axios.create({ baseURL: `${API}/admin/auth` });

export function makeAdminApi(onExpired) {
  const inst = axios.create({ baseURL: `${API}/admin` });
  inst.interceptors.request.use((cfg) => { cfg.headers["X-Admin-Session"] = getAdminSession() || ""; return cfg; });
  inst.interceptors.response.use((r) => r, (e) => {
    if (e?.response?.status === 404 && e.response.data?.detail === "Not Found") { setAdminSession(null); onExpired(); }
    return Promise.reject(e);
  });
  return inst;
}

export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" }) : "—");
